export const KEYWORDS_UPDATED: string = 'KEYWORDS_UPDATED'

export const keywordsUpdated = (keywords: string[]) => {
  return {
    type: KEYWORDS_UPDATED,
    data: keywords,
  }
}
